
//
// //
// // // For notifications
// //
//
var defaultWidth = window.screen.width > 768 ? window.screen.width * 1 / 3 : window.screen.width;

var appName = 'TDTA DIOCESE';

var copyRight = {
	name: 'Peace Soft',
	url: 'http://peacesoft.in',
	version: '1.0'
};

var isLocalHost = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
var envMode = isLocalHost ? 'local' : 'production';

var localApiUrl = 'http://localhost/git/TDTA%20EMPLOYMENT_2020-01-04/TDTA%20EMPLOYMENT/achr/index.php/';
var productionApiUrl = 'https://employment.csitirunelveli.org/achr/index.php/';
var apiUrl = productionApiUrl;

// Local-only UI access fallback. Must remain false in production.
//var enableRoleBypass = (envMode === 'local');
var enableRoleBypass = false;

var imagePath = {
	patientImage: apiUrl + 'public/uploads/patients/'
}

// *******************************
// Don't change this Secret key
//var PSJSC = 'B175001D4E951FaABbDAF98e13BI9';
var PSJSC = 'B17014E1FbDf9e1';
// Please keep it to working fine
// *******************************

var styles = {
	//headerBackground: 'linear-gradient(to right, rgb(232, 21, 0), rgb(255, 217, 26))',
	//headerBackground: 'linear-gradient(to right, rgb(5, 94, 127), rgb(12, 171, 75))',
	headerBackground: 'linear-gradient(90deg,#3baf30 0,#499ee4)',
	sidebarBorder: 'red'
};


module.exports = {
	defaultWidth,
	appName,
	imagePath,
	copyRight,
	apiUrl,
	envMode,
	enableRoleBypass,
	PSJSC,
	styles
};
